<script setup>
import { getTarget } from '~/utils/externalLink'
import { slugifyString } from '~/utils/slugify'

const props = defineProps({
  info: {
    type: String,
  },
  quote: {
    type: String,
    required: true,
  },
  person: {
    type: Object,
  },
})

const PROTOCOL_RE = /(^\w+:|^)\/\//

function stripProtocol(s) {
  return s.replace(PROTOCOL_RE, '')
}
</script>

<template>
  <div class="row justify-content-center">
    <div class="col-12 col-800-10 col-1200-8">
      <h2
        v-if="props.info"
        :id="slugifyString(props.info)"
        class="equal-small-2 equal-small-2--bold-uppercase info"
      >
        {{ props.info }}
      </h2>
      <Quotation
        v-if="props.quote"
        :text="props.quote"
      />
      <div
        v-if="props.person"
        class="d-flex align-items-start align-items-560-center flex-column flex-560-row person"
      >
        <NuxtImg
          v-if="props.person.image?.src"
          class="person__image"
          :src="props.person.image?.src"
          :alt="props.person.image?.alt"
          :placeholder="100"
          width="100"
          height="100"
          densities="1x 2x"
          loading="lazy"
          format="webp"
        />
        <div class="d-flex flex-column">
          <h3 class="equal-base equal-base--tighter-bold-uppercase">
            {{ props.person.name }}
          </h3>
          <div
            v-if="props.person.function"
            class="equal-base equal-base--tighter person__info"
          >
            {{ props.person.function }}
          </div>
          <div
            v-if="props.person.website"
            class="equal-base equal-base--tighter person__info"
          >
            <NuxtLink
              :to="props.person.website"
              class="equal-base equal-base--tighter person__info link"
              :target="getTarget(props.person.website)"
            >
              {{ stripProtocol(props.person.website) }}
            </NuxtLink>
          </div>
        </div>
      </div>
    </div>
  </div>
  <CmsContentInfoBox
    v-if="props.person.description"
    class="description"
    :text="props.person.description"
    :show-more="true"
  />
</template>

<style lang="scss" scoped>
@import '~/assets/scss/variables.scss';
@import 'bootstrap/scss/mixins';

.info {
  color: $color-disabled;
  margin-bottom: 20px;
}

.person {
  margin-top: 35px;

  &__image {
    width: clamp(80px, 1.39vw + 75.56px, 100px);
    height: clamp(80px, 1.39vw + 75.56px, 100px);
    border-radius: 50%;
    margin-right: 30px;
    object-fit: cover;
    background-color: $color-dark-01;

    @include media-breakpoint-down(560) {
      margin-right: 0;
      margin-bottom: 20px;
    }
  }

  &__info {
    margin-top: 10px;
  }
}

.description {
  margin-top: clamp(50px, 2.08vw + 43.33px, 80px);
}
</style>
